import validateMany from 'services/redux-form/validateMany';
import regex from 'services/regex';

const validate = (values) => {
  let _errors = {};

  if (values['name'] && values['name'].length < 3) {
    _errors['name'] = app.translate('main.minCharacters', {count: 3});
  }


  return _errors;
};

export default validate;
